(function ($) {
  var zeWidgetCustom = {};
  zeWidgetCustom.init = function () {
    if (typeof zE !== "function") return;

    // Disable zendesk widget
    if ($("body.enabled-zendesk-chat").length === 0) {
      zE("webWidget", "hide");
      return;
    }
    window.zESettings = {
      webWidget: {
        helpCenter: {
          originalArticleButton: false
        },
        color: {
          theme: "#ff4f00",
          launcher: "#ff4f00",
          launcherText: "#ffffff",
          button: "#ff4f00",
          header: "#ff4f00"
        }
      }
    };
    zE("webWidget", "setLocale", siteLang);
  };
  $(document).ready(function () {
    zeWidgetCustom.init();
  });
  $(window).resize(function () {
    zeWidgetCustom.init();
  });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/components/ze-widget.js